import { createAsyncType } from '@/store/utils/mutation-types'

export default {
  RESET: 'RESET',
  FORGOT_PASSWORD: createAsyncType('FORGOT_PASSWORD'),
  RESET_PASSWORD: createAsyncType('RESET_PASSWORD')
}
